import React, { useState, useCallback, useRef } from "react";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import { Marker } from "@react-google-maps/api";
import { ModalPaper, Container, MapContainer, ButtonsContainer } from "../styled";
import { ContainedButton } from "../../Buttons/ContainedButton";
import { AutoComplete } from "./AutoComplete";
import { Map } from "./Map";
import PropTypes from "prop-types";

const mapOptions = { mapTypeControl: false };
const backDropOptions = { timeout: 500 };

export const MapModal = ({ openModal, handleClose, lat, lng }) => {
  const [selectedPosition, setSelectedPosition] = useState({});
  const mapRef = useRef(null);

  const onMapLoad = useCallback(
    map => {
      mapRef.current = map;
      if (lat > 0 && lng > 0) {
        setSelectedPosition({ lat, lng });
      } else if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(position => {
          const { latitude, longitude } = position.coords;
          setSelectedPosition({ lat: latitude, lng: longitude });
        });
      } else {
        alert("Location not available");
      }
    },
    [lat, lng]
  );

  const onMapClick = useCallback(event => {
    const { latLng } = event;
    setSelectedPosition({ lat: latLng.lat(), lng: latLng.lng() });
  }, []);

  const panTo = useCallback(({ lat, lng, address_components }) => {
    setSelectedPosition({ lat, lng, address: address_components });
    mapRef.current.panTo({ lat, lng });
  }, []);

  const onMarkerDragEnd = useCallback(event => {
    const { latLng } = event;
    setSelectedPosition({ lat: latLng.lat(), lng: latLng.lng() });
  }, []);

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
      open={openModal}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={backDropOptions}
    >
      <ModalPaper>
        <Container>
          {mapRef?.current && <AutoComplete panTo={panTo} />}
          <Map
            mapContainerClassName={MapContainer}
            onClick={onMapClick}
            onLoad={onMapLoad}
            options={mapOptions}
            zoom={15}
            center={selectedPosition}
          >
            <Marker
              position={{ lat: selectedPosition.lat, lng: selectedPosition.lng }}
              draggable
              onDragEnd={onMarkerDragEnd}
            />
          </Map>
          <ButtonsContainer>
            <ContainedButton
              label="Close"
              handleClick={() => {
                handleClose(selectedPosition);
              }}
            />
          </ButtonsContainer>
        </Container>
      </ModalPaper>
    </Modal>
  );
};

MapModal.propTypes = {
  openModal: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  lat: PropTypes.number,
  lng: PropTypes.number
};
